import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const GCFComponentLayoutWrapper = (props: {
  children: React.ReactNode;
}) => {
  return (
    <Wrapper width="100%" height="100%">
      {props.children}
    </Wrapper>
  );
};
